
// document.addEventListener('DOMContentLoaded', function() {

//   const trigger = document.getElementById('reveal-trigger');
//   const content = document.getElementById('reveal-content');

//   if (!trigger || !content) return;

//   trigger.style.cursor = 'pointer';

//   trigger.addEventListener('click', function() {

//     // Show section
//     content.style.display = 'block';

//     // Wait for render then scroll
//     setTimeout(function() {
//       content.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//     }, 100);

//   }, { once: true });

// });

document.addEventListener('DOMContentLoaded', function() {

  const trigger = document.getElementById('reveal-trigger');
  const content = document.getElementById('reveal-content');

  if (!trigger || !content) return;

  trigger.style.cursor = 'pointer';
  content.style.position = 'relative';

  trigger.parentNode.insertBefore(content, trigger.nextSibling);

  const closeBtn = document.createElement('div');
  closeBtn.innerHTML = '&times;';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.style.position = 'absolute';
  closeBtn.style.right = '0px';
  closeBtn.style.top = '0px';
  closeBtn.style.cursor = 'pointer';
  closeBtn.style.fontSize = '26px';
  closeBtn.style.lineHeight = '1';
  closeBtn.style.zIndex = '10';
  closeBtn.style.width = '32px';
  closeBtn.style.height = '32px';
  closeBtn.style.display = 'flex';
  closeBtn.style.alignItems = 'center';
  closeBtn.style.justifyContent = 'center';

  content.appendChild(closeBtn);

  function openContent() {
    trigger.style.display = 'none';
    content.style.display = 'block';
  }

  function closeContent() {
    content.style.display = 'none';
    trigger.style.display = 'block';
  }

  trigger.addEventListener('click', openContent);
  closeBtn.addEventListener('click', closeContent);

  // ✅ Naviu part: form submit pachi page #contact_form sathe reload thay tyare
  // content ne automatically open j rakho (video nahi dekhadvu)
  if (window.location.hash === '#contact_form') {
    openContent();
  }

});